import { __rest } from 'tslib';
import React, { Children } from 'react';
import { Swiper as Swiper$1, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
import { styled } from '../../../libs/styled.es.js';
import { iconMap } from '../../atoms/SvgIcon/icons.es.js';

const Wrapper = styled.div(({ theme }) => `.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}
.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}
&:hover {
  .swiper-button-next,
  .swiper-button-prev {
    opacity: 1;
    &.swiper-button-disabled {
      opacity: 0.35;
    }
  }
}
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-top: -22px;
  background-color: rgba(168, 168, 168, 0.46);
  opacity: 0;
  &.swiper-button-disabled {
    opacity: 0;
    cursor: auto;
    pointer-events: auto;
  }
}
.swiper-pagination {
position: absolute;
text-align: center;
transform: translate3d(0, 0, 0);
z-index: 10;
}
.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #ddd;
}
.swiper-container-horizontal {
z-index: 0;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 4px;
  cursor: pointer;
}
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  left: 0;
  width: 100%;
}
.swiper-pagination-bullet-active {
  background: ${theme.brand.secondary};
  width: 24px;
  border-radius: 8px;
}
.swiper-button-next {
  right: 0;
  left: auto;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  &:after {
    mask: url("${iconMap['chevron-forward']}");
    content: ' ';
    height: 30px;
    width: 30px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
}
.swiper-button-prev {
left: 0;
right: auto;
border-top-right-radius: 100px;
border-bottom-right-radius: 100px;
&:after {
  mask: url("${iconMap['chevron-back']}");
  content: ' ';
  height: 30px;
  width: 30px;
  mask-size: contain;
  display: inline-block;
  background: #333;
}
}`);
const Swiper = (_a) => {
    var { children, hasNavigation, hasPagination, className } = _a, props = __rest(_a, ["children", "hasNavigation", "hasPagination", "className"]);
    const swiperProps = Object.assign({}, props);
    if (hasNavigation && !props.navigation) {
        swiperProps.navigation = true;
        SwiperCore.use([Navigation]);
    }
    if (hasPagination && !props.pagination) {
        swiperProps.pagination = true;
        SwiperCore.use([Pagination]);
    }
    const { slidesPerView = 'auto' } = swiperProps;
    const renderContent = (e, index, slidesPerView) => {
        return (React.createElement(SwiperSlide, { style: {
                maxWidth: (slidesPerView === 'auto' ? 100 : 100 / slidesPerView) + '%',
            }, key: index }, e));
    };
    return (React.createElement(Wrapper, { className: className },
        React.createElement(Swiper$1, Object.assign({}, swiperProps), Children.map(children, (e, index) => renderContent(e, index, slidesPerView)))));
};

export { Swiper };
